import { createFileRoute } from '@tanstack/react-router';

import { HelpCenterPage, helpSearchSchema } from '@/features/tours';

/** Every staff member may see it; it lists only the tours that person can take. */
export const Route = createFileRoute('/_authed/_active/help')({
  staticData: { crumb: 'common:nav.help', tours: ['help.center'] },
  validateSearch: helpSearchSchema,
  component: HelpCenterPage,
});
